import { MB } from './size.constants';

export const DEFAULT_PHOTO_ACCEPTED_FORMATS = 'jpg,png';
export const DEFAULT_MANUAL_UPLOAD_ACCEPTED_FORMATS = 'pdf';
export const DEFAULT_FILE_UPLOAD_MAX_SIZE = 10 * MB;
export const DEFAULT_MANUAL_UPLOAD_MAX_SIZE = 50 * MB;
